import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetRentalReport'
import Component from 'components/Reports/AssetRentalReport'

export default createListViewContainer({ actions, selectors: selectors.assetRentalReport })(Component)
